const EXCECOES = ["de", "da", "do", "das", "dos", "e"];

function cleanToken(nome: string): string {
  return String(nome)
    .normalize("NFC")
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .trim();
}

export function abreviarNome(nomeCompleto: string) {
  const nomes = (nomeCompleto || "")
    .trim()
    .split(/\s+/)
    .map(cleanToken)
    .filter(
      (nome) =>
        nome != null &&
        nome !== "" &&
        nome.toLowerCase() !== "undefined"
    );

  if (nomes.length === 0) {
    return "";
  }

  if (nomes.length <= 3) {
    return nomes.join(" ");
  }

  const primeiro = nomes[0];
  const ultimo = nomes[nomes.length - 1];
  const penultimo = nomes[nomes.length - 2];

  const abreviados = nomes.slice(1, -2).map((nome) => {
    if (EXCECOES.includes(nome.toLowerCase())) {
      return nome.toLowerCase();
    }
    const match = nome.match(/(\p{L})/u);
    const inicial = (match?.[1] || nome.charAt(0)).toUpperCase();
    return `${inicial}.`;
  });

  return [primeiro, ...abreviados, penultimo, ultimo].join(" ");
}
